module.exports = __webpack_public_path__ + "img/0Q3B7166_BlackMatted_MockedUp.9d0b510a.jpg";